import { Box, LinearProgress, Typography } from "@mui/material";

export type StatCardProps = {
  label: string;
  value: string;
  secondary?: string;
  caption?: string;
  barValue?: number;
  barColor?: "success" | "warning" | "primary" | "error";
};

export const StatCard = ({
  label,
  value,
  secondary,
  caption,
  barValue,
  barColor,
}: StatCardProps) => (
  <Box
    sx={{
      flex: 1,
      border: 1,
      borderColor: "divider",
      borderRadius: 1,
      backgroundColor: "background.paper",
      px: 2,
      py: 1.5,
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    <Typography
      variant="overline"
      color="text.secondary"
      sx={{ lineHeight: 1.2 }}
    >
      {label}
    </Typography>
    <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        {value}
      </Typography>
      {secondary && (
        <Typography variant="body2" color="text.secondary">
          {secondary}
        </Typography>
      )}
    </Box>
    {barValue !== undefined && (
      <LinearProgress
        variant="determinate"
        value={Math.min(100, Math.max(0, barValue))}
        color={barColor ?? "primary"}
        sx={{ height: 4, borderRadius: 2 }}
      />
    )}
    {caption && (
      <Typography variant="caption" color="text.secondary">
        {caption}
      </Typography>
    )}
  </Box>
);
